import { Fragment } from 'react';
import { t } from '@lingui/macro';
import { Table, TableBody, Alert } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PageLoader } from 'shared/domains/common-ui';
import { SearchResultsTableHead } from './SearchResultsTableHead';
import { SearchResultsTableRow } from './SearchResultsTableRow';
import { useSearchContext } from '../SearchProvider';
import { SearchResultsNoMatch } from '../SearchResultsNoMatch';
import { SearchResultsPagination } from '../SearchResultsPagination';
export function SearchResultsTable(props) {
    const { results = [], loading, error, totalResultsCount = 0, resultsLimit = 0 } = props;
    const { hiddenColRows, sortBy, setSortBy, columnConfigs } = useSearchContext();
    const { sortId, sortOrder } = sortBy || {};
    if (error) {
        return (<Alert appearance="danger" icon={<Falcon icon="circle-xmark"/>} message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>);
    }
    const noResults = results.length === 0 && !loading;
    if (noResults) {
        return <SearchResultsNoMatch />;
    }
    return (<Fragment>
      <Table dense hideColRows={hiddenColRows} sortId={sortId} sortOrder={sortOrder} onSort={(id, order) => {
            if (id)
                setSortBy(id, order);
        }}>
        <colgroup>
          <col width={32}/>
        </colgroup>

        <SearchResultsTableHead columnConfigs={columnConfigs}/>
        {!loading && (<TableBody>
            {results.map(result => (<SearchResultsTableRow key={result.id} result={result} columnConfigs={columnConfigs}/>))}
          </TableBody>)}
      </Table>
      {loading && <PageLoader />}

      <SearchResultsPagination totalCount={totalResultsCount} limit={resultsLimit}/>
    </Fragment>);
}
